// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ac-about-info-modal{padding-top:12px;padding-left:25px;padding-right:25px;padding-bottom:25px}.ac-about-info-modal__logo{display:block;margin:0 auto 2rem;width:8rem}.ac-about-info-modal__line{text-align:center}.ac-about-info-modal__line--emphasized{font-weight:700}.ac-about-info-modal__line--additional{font-size:1.2rem;margin-top:15px}.ac-about-info-modal__link{font-weight:700;text-decoration:underline}\n", ""]);
// Exports
module.exports = exports;
